(function () {
  'use strict';

  // ---- Mobile menu ----
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.querySelector('[data-mobile-nav]');
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
    });
  });

  // ---- Vehicle selector modal ----
  var modal = document.querySelector('[data-vehicle-modal]');
  function openModal() { if (modal) { modal.classList.add('is-open'); var f = modal.querySelector('select'); if (f) f.focus(); } }
  function closeModal() { if (modal) modal.classList.remove('is-open'); }
  document.querySelectorAll('[data-vehicle-open]').forEach(function (b) { b.addEventListener('click', openModal); });
  document.querySelectorAll('[data-vehicle-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  // Remember the chosen vehicle for this visitor (convenience only)
  var vehicleForm = document.querySelector('[data-vehicle-form]');
  if (vehicleForm) {
    try {
      var saved = JSON.parse(localStorage.getItem('tt_vehicle') || 'null');
      if (saved) {
        ['year', 'make', 'model'].forEach(function (k) { if (saved[k] && vehicleForm[k]) vehicleForm[k].value = saved[k]; });
        document.querySelectorAll('[data-vehicle-label]').forEach(function (el) { el.textContent = [saved.year, saved.make, saved.model].filter(Boolean).join(' '); });
      }
    } catch (e) {}
    vehicleForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = { year: vehicleForm.year.value, make: vehicleForm.make.value, model: vehicleForm.model.value.trim() };
      try { localStorage.setItem('tt_vehicle', JSON.stringify(v)); } catch (err) {}
      var q = [v.make, v.model, v.year].filter(Boolean).join(' ');
      window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search?type=product&q=' + encodeURIComponent(q);
    });
  }

  // ---- Testimonials slider ----
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    var slides = slider.querySelectorAll('.t-slide');
    var dots = slider.querySelectorAll('.t-dot');
    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i); });
    }
    function auto() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 6500); }
    var prev = slider.querySelector('[data-prev]'), next = slider.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); auto(); });
    if (next) next.addEventListener('click', function () { go(i + 1); auto(); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); auto(); }); });
    if (slides.length > 1) auto();
  });

  // ---- Product gallery ----
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.js-gallery-main');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (!main) return; main.src = t.getAttribute('data-src');
        main.srcset = '';
      });
    });
  });

  // ---- Variant picker ----
  document.querySelectorAll('.js-product-form').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[name="id"]');
    var btn = form.querySelector('[data-atc]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    function money(cents) { return (window.TT && TT.money ? TT.money : '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2)); }
    function update() {
      var chosen = [];
      form.querySelectorAll('.variant-group').forEach(function (grp) {
        var c = grp.querySelector('input:checked'); chosen.push(c ? c.value : null);
      });
      var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === chosen[k]; }); });
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    form.addEventListener('change', function (e) { if (e.target.closest('.variant-group')) update(); });
  });

  // ---- Quantity steppers ----
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10) + (b.hasAttribute('data-plus') ? 1 : -1);
        input.value = Math.max(parseInt(input.min || '1', 10), v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // ---- Reveal on scroll ----
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
